import React from "react";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "@/modules/auth/hooks/useAuth";
import { FullScreenLoader } from "@/shared/components/FullScreenLoader";

interface UnverifiedOnlyRouteProps {
  children: ReactNode;
}

// Renders only when the user is authenticated but has not yet verified their email.
// Sits alongside PrivateRoute (verified) and PublicRoute (anonymous) — three guards,
// one responsibility each.
export const UnverifiedOnlyRoute: React.FC<UnverifiedOnlyRouteProps> = ({ children }) => {
  const { isAuthenticated, isInitialized, user } = useAuth();

  // Gate on isInitialized, never isLoading — see PrivateRoute.
  if (!isInitialized) {
    return <FullScreenLoader />;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/auth/register" replace />;
  }

  if (user.email_verified_at) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
};
